export const initialState = {
  protocolo: '',
  formularioLista: [],
  envio: {
    loading: false,
    error: '',
    lastProtocolo: '',
    lastFormulario: '',
  },
  rascunho: {
    loading: false,
    error: '',
  },
  peritos: [],
  deferido: [],
  indeferido: [],
  emAndamento: [],
  pendenteCorrecao: [],
  allForms: [],
  allFormsRequestDone: false,
  allFormsByStatusDone: {},
  allFormsLabels: [],
  allFormsLabelsRequestDone: false,
  loadingStatus: false,
  loadingForms: false,
  dadosPessoaisRequerimento: {
    email: '',
    celular: '',
    telefoneFixo: '',
    nome: '',
    dtNascimento: '',
    nacionalidade: '',
    sexo: '',
    estadoCivil: '',
    pai: '',
    mae: '',
    rg: '',
    orgEmissor: '',
    uf: '',
    cpf: '',
    dtEmissao: '',
    endereco: '',
    numero: '',
    complemento: '',
    cep: '',
    bairro: '',
    cidade: '',
    estado: '',
    banco: '',
    agencia: '',
    conta: '',
    digito: '',
  },
};
